import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import ModalFixed from "../../components/ModalFixed";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import Notification from "../../components/Notification";

import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";

import { PosgradoPostulacionFixed } from "../../components/Pasos";
import Modal from "../../components/Modal";

function Posgrados() {
  const DataDisplayOferta = ({ data }) => (
    <>
      <div className="wrapper-academicoffer">
        {data.map((item, index) => (
          <div>
            <div class="programa-imagen">
              <img src={item.field_portada} alt={item.title} />
            </div>
            <div className="layout8">
              <div class="flex-start">
                <p class="tipoposgrado"> {item.field_programa}</p>

                {item.tag && <p class="tag-2">{item.tag}</p>}
              </div>
              <h3>{item.title}</h3>
              {item.field_modalidad?.[0] && (
                <p>
                  <b>Modalidad:</b> {item.field_modalidad}
                </p>
              )}

              {item.field_modalidad_carrera?.[0] && (
                <p>
                  <b>Modalidad:</b> {item.field_modalidad_carrera}
                </p>
              )}

              {item.field_duracion?.[0] && (
                <p>
                  <b>Duración:</b> {item.field_duracion}
                </p>
              )}

              {item.field_posgrado_duracion?.[0] && (
                <p>
                  <b>Duración:</b> {item.field_posgrado_duracion}
                </p>
              )}

              {item.field_posgrado_campo?.[0] && (
                <p>
                  <b>Campo del conocimiento:</b> {item.field_posgrado_campo}
                </p>
              )}

              {item.field_campo_amplio_del_conocimie?.[0] && (
                <p>
                  <b>Campo del conocimiento:</b>{" "}
                  {item.field_campo_amplio_del_conocimie}
                </p>
              )}

              {item.field_area?.[0] && (
                <p>
                  <b>Facultad:</b> {item.field_area}
                </p>
              )}

              {item.field_inicio?.[0] && (
                <p>
                  <b>Inicio de clases:</b> {item.field_inicio}
                </p>
              )}

              {item.field_enlace_contenido?.[0] && (
                <div className="wrapper-link">
                  <a
                    className="link-offer"
                    href={item.field_enlace_contenido}
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons">arrow_forward_ios</span>
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="relative">
              <Notification
                content={
                  <>
                    <PosgradoPostulacionFixed></PosgradoPostulacionFixed>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.bloque1,
                      }}
                    />

                    <Modal
                      title="🔍 Conoce el proceso de postulación y matrícula"
                      content={
                        <>
                          <div>
                            <iframe
                              width="100%"
                              height="569"
                              src="https://www.youtube.com/embed/RxpCoV2UShM"
                              title="Posgrados UTPL | Admisión y matrícula paso a paso"
                              frameborder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                              referrerpolicy="strict-origin-when-cross-origin"
                              allowfullscreen
                            ></iframe>
                          </div>
                        </>
                      }
                    ></Modal>
                  </>
                }
              ></Notification>
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/posgrados">Posgrados</NavLink>
                </>
              }
            ></Breadcumbs>
            <div
              className="layout8"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque2,
              }}
            />
            <div className="margin">
              <DataFetcherTemplate url="https://utpl.edu.ec/maestrias/services/posgrados.json">
                {(data) => <DataDisplayOferta data={data} />}
              </DataFetcherTemplate>
            </div>
            {/*     <div className="padding">
              <PosgradoPagos></PosgradoPagos>
            </div> */}
            <div className="margin">
              <BlockBackgroundImage
                src={item.field_imagen4}
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque4,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-posgrados-new.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <ConectUs
        facebook="https://www.facebook.com/utpltec/"
        instagram="https://www.instagram.com/utpltec/"
        tiktok="https://www.tiktok.com/@utpltec"
        x="https://twitter.com/utpl?lang=es"
        youtube="https://www.youtube.com/user/utpl/"
        linkedin="https://www.linkedin.com/company/utpl-tec/"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Posgrados;
